export const sanitisePreviewValue = previewValue => previewValue
  .replace(/"/gm, '')
  .replace(/(\\r\\n|\\n|\\r)/gm, '')
  .replace(/\\\//gm, '/')
  .replace(/\\/gm, '');
